// Publishes which plate-capture phase the CANpark home tab is in so the
// ticketing tour can pick the right (click-through) step + placement:
//   'camera'  — full-screen viewfinder      -> top-centre popover
//   'manual'  — bottom "Enter license plate" sheet -> popover on the sheet
//   'preview' — post-scan review screen      -> top-centre popover
//   'none'    — not capturing
// Single-instance app, so a module store is fine.

export type TicketCaptureMode = 'none' | 'camera' | 'manual' | 'preview';

type Listener = () => void;

let mode: TicketCaptureMode = 'none';
const listeners = new Set<Listener>();

export const setTicketCaptureMode = (value: TicketCaptureMode): void => {
	if (mode === value) return;
	mode = value;
	listeners.forEach((l) => l());
};

export const subscribeTicketCapture = (listener: Listener): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

export const getTicketCaptureMode = (): TicketCaptureMode => mode;

// A closer the home tab registers so the tour can dismiss whatever capture UI is
// open (camera / manual sheet / preview) — e.g. when the user clicks Back on the
// capture step. Closing it flips captureMode to 'none', so the sync hook returns
// the tour to the scan step.
let closer: (() => void) | null = null;

export const setTicketCaptureCloser = (fn: (() => void) | null): void => {
	closer = fn;
};

export const closeTicketCapture = (): void => {
	closer?.();
};

// A "go back a stage" handler the drawer host registers so the tour's Back button
// on in-drawer steps drives the app's own back (goBack, or close the drawer at
// the first stage) instead of naively decrementing the step index — which the
// sync hook would immediately undo, leaving Back stuck.
let drawerBack: (() => void) | null = null;

export const setTicketDrawerBack = (fn: (() => void) | null): void => {
	drawerBack = fn;
};

export const ticketDrawerBack = (): void => {
	drawerBack?.();
};
